module.exports = __webpack_public_path__ + "img/empty-state.de5eee0c.png";